// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { BidPackageDetailPage_TradeFragmentDoc } from './AddTradePartnerModal.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type EditTradeContactsModalQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type EditTradeContactsModalQuery = { __typename?: 'Query', tradePartner: { __typename?: 'TradePartner', id: string, name: string, contacts: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, email?: string | null | undefined, mobilePhone?: string | null | undefined, isPrimary: boolean }>, costCodes: Array<{ __typename?: 'CostCode', id: string }> } };


export const EditTradeContactsModalDocument = gql`
    query EditTradeContactsModal($id: ID!) {
  tradePartner(id: $id) {
    ...BidPackageDetailPage_Trade
  }
}
    ${BidPackageDetailPage_TradeFragmentDoc}`;

/**
 * __useEditTradeContactsModalQuery__
 *
 * To run a query within a React component, call `useEditTradeContactsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditTradeContactsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditTradeContactsModalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditTradeContactsModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EditTradeContactsModalQuery, EditTradeContactsModalQueryVariables> & ({ variables: EditTradeContactsModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditTradeContactsModalQuery, EditTradeContactsModalQueryVariables>(EditTradeContactsModalDocument, options);
      }
export function useEditTradeContactsModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditTradeContactsModalQuery, EditTradeContactsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditTradeContactsModalQuery, EditTradeContactsModalQueryVariables>(EditTradeContactsModalDocument, options);
        }
// @ts-ignore
export function useEditTradeContactsModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EditTradeContactsModalQuery, EditTradeContactsModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditTradeContactsModalQuery, EditTradeContactsModalQueryVariables>;
export function useEditTradeContactsModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditTradeContactsModalQuery, EditTradeContactsModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditTradeContactsModalQuery | undefined, EditTradeContactsModalQueryVariables>;
export function useEditTradeContactsModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditTradeContactsModalQuery, EditTradeContactsModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EditTradeContactsModalQuery, EditTradeContactsModalQueryVariables>(EditTradeContactsModalDocument, options);
        }
export type EditTradeContactsModalQueryHookResult = ReturnType<typeof useEditTradeContactsModalQuery>;
export type EditTradeContactsModalLazyQueryHookResult = ReturnType<typeof useEditTradeContactsModalLazyQuery>;
export type EditTradeContactsModalSuspenseQueryHookResult = ReturnType<typeof useEditTradeContactsModalSuspenseQuery>;
export type EditTradeContactsModalQueryResult = Apollo.QueryResult<EditTradeContactsModalQuery, EditTradeContactsModalQueryVariables>;